export const AppEnvironment = {
    AppName: process.env.REACT_APPNAME,
    AppPrefix: "AppGall_",
  };
  
  export const UserTypes = {
    Team: "1",
    Buyer: "2",
    Supplier: "3",
    Staff: "4",
  };